(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('ApplicationParameterSearch', ApplicationParameterSearch);

    ApplicationParameterSearch.$inject = ['$resource'];

    function ApplicationParameterSearch($resource) {
        var resourceUrl =  'api/_search/application-parameters/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
